import type { OrderType } from '@/api/models/OrderSearch';
import type { SearchMode } from './SearchTextFilter';

// The base ESLint rule does not recognize TypeScript enum member usage.
/* eslint-disable no-unused-vars */
export enum OrdersPageType {
  Clubs = 'Clubs',
  Components = 'Components',
  Putters = 'Putters',
}
/* eslint-enable no-unused-vars */

interface OrdersPresentation {
  orderType: OrderType;
  orderStatuses: string[];
  searchModes: SearchMode[];
  defaultSearchMode: SearchMode;
  showPlayer: boolean;
  showClubs: boolean;
  showBuildLocation: boolean;
  showShippingLocations: boolean;
  tourRepInFirstRow: boolean;
  detailPageType: string;
}

const commonOrderStatuses = ['Submitted', 'Completed', 'Cancelled', 'Build', 'Printed', 'Completed Partial', 'Partial', 'Saved'];

export const ordersPresentation: Record<OrdersPageType, OrdersPresentation> = {
  [OrdersPageType.Clubs]: {
    orderType: 'club',
    orderStatuses: commonOrderStatuses,
    searchModes: ['player', 'order', 'serial'],
    defaultSearchMode: 'player',
    showPlayer: true,
    showClubs: true,
    showBuildLocation: true,
    showShippingLocations: false,
    tourRepInFirstRow: false,
    detailPageType: 'order',
  },
  [OrdersPageType.Components]: {
    orderType: 'component',
    orderStatuses: [...commonOrderStatuses, 'Received'],
    searchModes: ['order'],
    defaultSearchMode: 'order',
    showPlayer: false,
    showClubs: true,
    showBuildLocation: false,
    showShippingLocations: true,
    tourRepInFirstRow: true,
    detailPageType: 'comporder',
  },
  [OrdersPageType.Putters]: {
    orderType: 'putter',
    orderStatuses: [...commonOrderStatuses, 'Update Address', 'Ready to Ship'],
    searchModes: ['player', 'order'],
    defaultSearchMode: 'player',
    showPlayer: true,
    showClubs: false,
    showBuildLocation: true,
    showShippingLocations: false,
    tourRepInFirstRow: false,
    detailPageType: 'putterorder',
  },
};

export const getOrdersPage = (hash: string): OrdersPageType => {
  if (hash.toLowerCase() === '#putters') return OrdersPageType.Putters;
  if (hash.toLowerCase() === '#components') return OrdersPageType.Components;
  return OrdersPageType.Clubs;
};
